import { render, staticRenderFns } from "./PortCall.vue?vue&type=template&id=a6d9b06a&scoped=true&"
import script from "./PortCall.vue?vue&type=script&lang=js&"
export * from "./PortCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d9b06a",
  null
  
)

export default component.exports